export default "/images/007ac13825d0d4d1c7193288d100dfc1.avif";